var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { PatientConsentViewModel } from "./PatientConsentViewModel";
import { NOT_LOADED } from "../Infra/RemoteData";
import { i18nGetDateFnsLocale } from "../Infra/i18next";
import { format } from "date-fns";
export class PatientConsentInterventionalEnrollmentLengthOfResearchViewModel extends PatientConsentViewModel {
    get startDate() {
        var _a;
        if (this.study === NOT_LOADED || this.study === null)
            return null;
        const startDate = (_a = this.study.informedConsentStartDate) !== null && _a !== void 0 ? _a : this.study.startDate;
        if (!startDate)
            return "No start date specified";
        return format(new Date(startDate), "LLLL d, yyyy", { locale: i18nGetDateFnsLocale() });
    }
    get endDate() {
        var _a;
        if (this.study === NOT_LOADED || this.study === null)
            return null;
        const completionDate = (_a = this.study.informedConsentCompletionDate) !== null && _a !== void 0 ? _a : this.study.completionDate;
        if (!completionDate)
            return "No end date specified";
        return format(new Date(completionDate), "LLLL d, yyyy", { locale: i18nGetDateFnsLocale() });
    }
    get targetNumberOfPatients() {
        var _a;
        if (this.study === NOT_LOADED || this.study === null)
            return 0;
        return (_a = this.study.informedTargetNumberOfPatients) !== null && _a !== void 0 ? _a : this.study.targetNumberOfPatients;
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentInterventionalEnrollmentLengthOfResearchViewModel.prototype, "startDate", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentInterventionalEnrollmentLengthOfResearchViewModel.prototype, "endDate", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentInterventionalEnrollmentLengthOfResearchViewModel.prototype, "targetNumberOfPatients", null);
